app.yourScriptName = {
  name: 'yourScriptName',
  description: 'your script description',
  init() {
    // your code
  },
};
